export default class EventsPageView {
    constructor() {
        this.$header = $('.wg-header');
        this.$mainEventSection = $('#section-main-event');
        this.$sectionUpcomingEvents = $('#section-upcoming-events');
        this.$pageLoader = $('#page-loader');

        this.$events = {
            upcoming: null,
            recent: null
        };

        this.$moreEventsBtns = $('.more-events-btn');
        this.$filters = $('.events-filter');

        this.templates = {
            mainEvent: $('#main-event-template').html(),
            upcoming: $('#upcoming-events-template').html(),
            recent: $('#recent-events-template').html()
        };
    }

    setHeaderDarkTheme() {
        $(() => this.$header.wgInstance().setTheme('dark'));
    }

    onMoreEventsBtnClick(callback) {
        this.$moreEventsBtns.on('click', function() {
            const eventsType = $(this).data('events-type');

            callback(eventsType);
        });
    }

    onEventsFilterChange(callback) {
        this.$filters.on('click', function(event) {
            const $filter = $(this);
            const $target = $(event.target);
            const eventsType = $filter.data('events-type');

            $filter.removeClass('dropdown-hidden');

            if ($target.hasClass('events-filter__item') && !$target.hasClass('active')) {
                return callback($target.data('filter'), eventsType);
            }
        });

        this.$filters.on('mouseenter', function() {
            $(this).removeClass('dropdown-hidden');
        });
    }

    onCategoryChange(callback) {
        $('[data-category]').on('click', function() {
            const $categoryItem = $(this);
            const category = $(this).data('category');

            if (!$categoryItem.hasClass('active')) {
                $categoryItem
                    .addClass('active')
                    .siblings()
                    .removeClass('active');

                return callback(category);
            }
        });
    }

    renderFilter(location, eventsType) {
        const $filter = $('#' + eventsType + '-events-filter');
        const $filterTitle = $filter.find('.events-filter__title');
        const $filterItems = $filter.find('.events-filter__item');
        const $activeFilterItem = $filter.find('[data-filter="' + location + '"]');

        $filter.addClass('dropdown-hidden');
        $filterTitle.text($activeFilterItem.text());
        $filterItems.removeClass('active');
        $activeFilterItem.addClass('active');
    }

    onEventLinkClick(callback) {
        this.$mainEventSection.on('click', function(event) {
            const $target = $(event.target);

            if ($target.hasClass('main-event__info-link')) {
                const eventLink = $target.attr('href');
                const eventName = $target.siblings('.main-event__title').text();

                return callback('MAIN_EVENT_LINK_CLICK', {
                    detail: { link: eventLink, name: eventName }
                });
            }
        });

        $('.event').on('click', function(event) {
            const $event = $(this);
            const eventType = $event.data('event-type');
            const $target = $(event.target);

            if ($target.is('a')) {
                const eventLink = $target.attr('href');
                const eventName = $event.find('.event-title').text();

                return callback(eventType.toUpperCase() + '_EVENT_LINK_CLICK', {
                    detail: { link: eventLink, name: eventName }
                });
            }
        });
    }

    showEvents(maxVisibleEventsCount, eventsType) {
        const $btn = this.$moreEventsBtns.filter('[data-events-type="' + eventsType + '"]');

        if (maxVisibleEventsCount >= this.$events[eventsType].length) {
            $btn.hide();
        } else {
            $btn.show();
        }

        this.$events[eventsType].slice(0, maxVisibleEventsCount).addClass('visible');
    }

    renderEvents(events, eventsType) {
        const $section = $('#section-' + eventsType + '-events');
        const template = this.templates[eventsType] || '';
        const defaultMaxVisibleEvents = 6;

        Mustache.parse(template);
        const html = Mustache.render(template, { events: events });

        $section.find('.events').html(html);

        this.$events[eventsType] = $section.find('.event');
        this.showEvents(defaultMaxVisibleEvents, eventsType);
    }

    renderMainEventSection(event) {
        Mustache.parse(this.templates.mainEvent);
        const html = Mustache.render(this.templates.mainEvent, event);

        this.$mainEventSection.removeClass('isEmpty');
        this.$mainEventSection.html(html);
    }

    hideLoader() {
        this.$pageLoader.hide();
    }
}



// WEBPACK FOOTER //
// ./assets/js/projects/events/includes/view.js